import { gql } from "@apollo/client";

export const CREATE_OR_UPDATE_ORDEN_PEDIDO = gql`
  mutation CreateOrUpdateOrdenPedido(
    $idOrdenPedido: Int!
    $idDelegacion: Int!
    $idEvaluacion: Int!
    $fechaEntrega: CustomDateTime!
    $idEstado: Int!
    $diasPedido: Int!
    $idStockOrigen: Int!
    $calle: String!
    $cP: String!
    $localidad: String!
    $observacion: String!
    $pais: String!
    $provincia: String!
    $telefono: String!
    $ordenPedidoInsumo: [OrdenPedidoInsumoModelInput!]!
    $complejidadPlan: Boolean!
    $idResultadoPresupuesto: Int!
    $diasCO: Int!
    $diasFacturacion: Int!
  ) {
    createOrUpdateOrdenPedido(
      input: {
        ordenPedido: {
          idOrdenPedido: $idOrdenPedido
          idDelegacion: $idDelegacion
          idEvaluacion: $idEvaluacion
          fechaEntrega: $fechaEntrega
          idEstado: $idEstado
          diasPedido: $diasPedido
          idStockOrigen: $idStockOrigen
          complejidadPlan: $complejidadPlan
          idResultadoPresupuesto: $idResultadoPresupuesto
          diasCO: $diasCO
          diasFacturacion: $diasFacturacion
        }
        ordenPedidoEnvio: {
          calle: $calle
          cP: $cP
          localidad: $localidad
          observacion: $observacion
          pais: $pais
          provincia: $provincia
          telefono: $telefono
        }
        ordenPedidoInsumo: $ordenPedidoInsumo
      }
    ) {
      success
      error
      valorEsperado
    }
  }
`;